export default {
	label: 'Method responsibles and cost',
	changes: 'Changes',
	method: 'method | methods',
	changesTooltip: 'Changes over the course of days',
	goToMethodsPage: 'Click to see filtered methods',
	responsibles: 'Responsibles',
	serviceProviders: 'Service providers',
	goToOverdueMethods: 'Click to see overdue methods',
}
